import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';

const Header = () => {
  const [isSticky, setIsSticky] = useState(false);
  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsSticky(true);
    } else {
      setIsSticky(false)
    }
  }
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll)
  })
  const handleScrollNav = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <>
      <header className={`main-header ${isSticky ? 'fixed-header' : ''}`}>
        <div className="header-upper"><div className="container">
          <div className="header-inner d-flex align-items-center">
            <div className="logo-outer">
              <div className="logo">
                <Link href="#"><img src="./zahid.jpeg" alt="Logo" title="Logo" /></Link>
              </div>
            </div>
            <div className="nav-outer">
              <nav className="main-menu navbar-expand-lg">
                <div className="navbar-header">
                  <div className="mobile-logo">
                    <Link href="#"><img src="./zahid.jpeg" alt="Logo" title="Logo" /></Link>
                  </div>
                  <button type="button" className="navbar-toggle" data-bs-toggle="collapse" data-bs-target=".navbar-collapse"><span className="icon-bar"></span>
                    <span className="icon-bar"></span><span className="icon-bar"></span>
                  </button>
                </div>
                <div className="navbar-collapse collapse">
                  <ul className="navigation onepage clearfix">
                    <li><Link onClick={() => handleScrollNav('home')} className="nav-link-click active">Home</Link></li>
                    <li><Link onClick={() => handleScrollNav('about')} className="nav-link-click">About</Link></li>
                    <li><Link onClick={() => handleScrollNav('services')} className="nav-link-click">Services</Link></li>
                    <li><Link onClick={() => handleScrollNav('resume')} className="nav-link-click">Resume</Link></li>
                    <li><Link onClick={() => handleScrollNav('portfolio')} className="nav-link-click">Projects</Link></li>
                    <li><Link onClick={() => handleScrollNav('contact')} className="nav-link-click">Contact</Link></li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
        </div>
      </header>
    </>
  )
}

export default Header